//*********************************
// aos
//*********************************

console.log('aos');

import AOS from 'aos';
AOS.init();
